module.exports = __webpack_public_path__ + "media/img/pages/profile/fenaco ger 1-8baaf80a6c3789ffe92fe917ff66a564.jpg";